<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"
  ><path fill="none" stroke="#C10016" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m3 6 5 5 5-5" /></svg
>
